import { Address } from '@akin-home/amplify';
import { RecordWithImageFields } from '@akin-home/images';
import { Record } from '@akin-home/records';

export interface ContactModel extends RecordWithImageFields, Record {
  habitatID: string;
  name: string;
  type?: string;
  tags: string[];
  phoneNumbers: PhoneNumber[];
  emailAddresses: string[];
  notes: string[];
  contactColor: string;
  stockImage?: string;

  addresses?: Address[];

  user_id?: string;

  addPhoneNumber(this: ContactModel, phoneNumber?: PhoneNumber): ContactModel;
  removePhoneNumber(this: ContactModel, idx: number): ContactModel;
  updatePhoneNumber(
    this: ContactModel,
    idx: number,
    phoneNumber: PhoneNumber
  ): ContactModel;
  hasPhoneNumber(this: ContactModel): boolean;
}

export enum PhoneTypes {
  Work = 'Work',
  Home = 'Home',
  Mobile = 'Mobile',
  Personal = 'Personal',
  Support = 'Support',
  Emergency = 'Emergency',
  Custom = 'Custom',
}

export enum ContactTypes {
  Family = 'Family',
  Friend = 'Friend',
  Neighbour = 'Neighbour',
  Support = 'Support',
  Work = 'Work',
  School = 'School',
  Emergency = 'Emergency',
  Custom = 'Custom',
}

export enum ContactTypeEmojis {
  Family = '👪',
  Friend = '👥',
  Neighbour = '🏠',
  Support = '🤝',
  Work = '💼',
  School = '🏫',
  Emergency = '🚑',
  Custom = '',
}

export interface PhoneNumber {
  number: string;
  type: PhoneTypes;
}
